import {
  Badge,
  Box,
  Button,
  Card,
  CardMedia,
  Dialog,
  FormControlLabel,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Switch,
  Tooltip,
} from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Paper from '@material-ui/core/Paper';
import FileExport from 'components/Icons/FileExport';
import {
  Add,
  AddRounded,
  LinkIcon,
  MoreHoriz,
  VisibilityRounded,
} from '@material-ui/icons';
import RoomIcon from '@material-ui/icons/Room';
import {
  getInfosIndividual,
  getInfosDashboard,
  getProfilePreferences,
  getProfilePresentation,
  updateProfilePreferencesIndivudual,
} from '@webapps/business';
import {
  Modal,
  ModalSideBar,
  useAuth,
  useMutation,
  useQuery,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import CropEasy from 'components/crop/CropEasy';
import VerifiedIcon from 'components/Icons/VerifiedIcon';
import ProfilAffiliate from 'components/Profil/ProfilAffiliate';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import DownloadIcon from './icons/downloadIcon';
import ShareIcon from './icons/shareIcon';
import theme from './theme';
import FullScreenModal from '../ModalFullScreen';
import CVStudent from 'pages/student/Cv';

const {
  colors: { background },
} = theme;

const ProfilName = () => {
  const {
    cx,
    coverImage,
    classes,
    css,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const [updateCoor, setUpdateCoor] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [testcoverImageUrl, setTestCoverImageUrl] = useState(coverImage);
  const { idUser } = useAuth();

  const handleViewVitrine = () => {
    history.push(ROUTES_PATH.MY_VITRINE_BUSINESS);
  };

  const { addToast } = useToast();
  const [openCrop, setOpenCrop] = useState(false);
  const [openCropProfile, setOpenCropProfile] = useState(false);
  const [anchorCandid, setAnchorCandid] = useState(null);

  const openCandid = Boolean(anchorCandid);

  const handleClick = (event) => {
    setAnchorCandid(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorCandid(null);
  };
  const {
    data: infos = {},
    isLoadingProfilInfo,
    refetch: refetchInfoProfil,
  } = useQuery(getInfosIndividual, {
    key: ['profilInfoID', idUser],
    variables: { id: idUser },
  });

  const { data: { profileImageUrl = '' } = {}, refetch } = useQuery(
    getProfilePresentation,
    {
      key: 'coverImageProfilCV',
      variables: { id: idUser },
    }
  );

  const { data: { coverImageUrl = '' } = {}, refetch: refetchCoverImg } =
    useQuery(getProfilePresentation, {
      key: 'coverImageUrl',
      variables: { id: idUser },
      onSuccess: (data) => {
        setTestCoverImageUrl(coverImageUrl);
      },
    });

  useEffect(() => {
    setTestCoverImageUrl(coverImageUrl);
  }, [coverImageUrl]);

  const { data: preferences = {}, refetch: refetchProfilPreference } = useQuery(
    getProfilePreferences,
    {
      key: 'preferences',
      variables: { id: idUser },
    }
  );

  const {
    // error,
    isLoading: isLoadingVisibility,
    isSuccess: isScuccesVisibleCV,
    mutateAsync: mutateUpdatePreferences,
  } = useMutation(updateProfilePreferencesIndivudual);

  const setVisibilityOnCV = async (id) => {
    await mutateUpdatePreferences({
      status: !preferences?.visibleOnCvLibrary,
      type: 'visible_on_cv_library',
      id,
    });
    refetchProfilPreference();
  };

  const [viewProfil, setViewProfil] = useState(false);
  const [openInfo, setOpenInfo] = useState(false);
  const [openCreateCV, setOpenCreateCV] = useState(false);

  const handleOpenViewProfil = () => {
    setViewProfil(true);
  };
  const handleCloseViewProfil = () => {
    setViewProfil(false);
  };

  const handleOpenCreateCV = () => {
    setOpenCreateCV(true);
  };

  const handleCloseCreateCV = () => {
    setOpenCreateCV(false);
  };

  useEffect(() => {
    if (isScuccesVisibleCV) {
      if (preferences?.visibleOnCvLibrary) {
        addToast({
          status: 'success',
          message: 'Non visible dans la CVthèque',
        });
      } else {
        addToast({
          status: 'success',
          message: 'Visible dans la CVthèque',
        });
      }
    }
  }, [isScuccesVisibleCV]);


  return (
    <div className={classes.container}>
      <div className={classes.flex}>
        {/* Logique d'ajout de bannière utilisateur
          ------------------------------------------------ */}
        <Paper className={css({ position: 'relative' })} elevation={0}>
          {testcoverImageUrl ? (
            <Card elevation={0}>
              <CardMedia
                component="img"
                image={testcoverImageUrl}
                title="cover image"
              />
            </Card>
          ) : (
            <div
              className={cx(
                classes.title,
                global.title,
                css({
                  background: '#0060F9',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                })
              )}
            >
              <div>{name}</div>
            </div>
          )}
          <div>
            <IconButton
              className={css({
                position: 'absolute',
                top: 15,
                right: 15,
                background: '#F3F7FF',
                border: '1px solid #C0D9FF',
                width: '24px',
                height: '24px',
                '&:hover': {
                  backgroundColor: '#F3F7FF',
                },
              })}
              onClick={() => setOpenCrop(true)}
              size="small"
            >
              <AddRounded style={{ color: '#5A6DA1', fontSize: '15.0px' }} />
            </IconButton>
          </div>
        </Paper>
        <Dialog
          BackdropProps={{
            style: {
              backgroundColor: 'rgba(0, 45, 117, 0.6)',
            },
          }}
          classes={{
            paperScrollPaper: css({
              width: '100%',
              maxWidth: 1000,
              borderRadius: 10,
              '@media screen and (max-width: 768px)': {
                margin: '10px',
              },
            }),
          }}
          onClose={() => setOpenCrop(false)}
          open={openCrop}
        >
          <CropEasy
            {...{
              photoURL: coverImage,
              setOpenCrop,
              type: 'cover',
              refresh: refetchCoverImg,
            }}
          />
        </Dialog>
        {/* Logique d'ajout de bannière utilisateur
          ------------------------------------------------ */}
        <div className={classes.ProfilNameContainer}>
          <div className={classes.photo}>
            <Badge
              className={css({
                position: 'absolute',
                bottom: -50,
                left: 110,
              })}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              badgeContent={
                <IconButton
                  className={css({
                    marginBottom: '40px',
                    marginRight: '40px',
                    border: '1px solid #C0D9FF',
                    backgroundColor: '#F3F7FF',
                    cursor: 'pointer',
                    '&:hover': {
                      border: '1px solid #C0D9FF',
                      backgroundColor: '#F3F7FF',
                    },
                    padding: 0,
                  })}
                  onClick={() => setOpenCropProfile(true)}
                >
                  <Add className={css({ color: '#5A6DA1' })} />
                </IconButton>
              }
              overlap="circular"
            >
              {profileImageUrl ? (
                <Avatar className={classes.avatar} src={profileImageUrl} />
              ) : (
                <Avatar className={classes.avatar}>
                  {infos?.firstname?.substr(0, 1) +
                    infos?.lastname?.substr(0, 1)}
                </Avatar>
              )}
            </Badge>
          </div>
          <div className={classes.profilName}>
            <div className={cx(global.title, classes.name)}>
              <div>
                {infos?.firstname} {infos?.lastname}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={classes.ProfilButtonContainer}>
        <Grid container xs={12} spacing={1} className={classes.actionContainer}
        >
          <Button
            className={css({
              height: '40px',
              display: 'flex',
              justifyContent: 'center',
              borderRadius: 25,
              alignItems: 'center',
              fontWeight: 600,
              padding: '0 15px',
            })}
            style={
              preferences.visibleOnCvLibrary
                ? { backgroundColor: '#DBFAD8', color: '#008000' }
                : {
                  backgroundColor: '#F3F7FF',
                  color: '#5A6DA1',
                  border: '1px solid #C0D9FF',
                }
            }
          >
            <FormControlLabel
              control={
                <Switch
                  classes={{
                    switchBase: css({
                      color: '#ccc',
                      '&.Mui-checked': css({
                        color: '#FFF',
                      }),
                      '&.Mui-checked + .MuiSwitch-track': css({
                        backgroundColor: '#8FE685',
                      }),
                    }),
                    checked: css({}),
                    track: css({}),
                  }}
                  color="#008000"
                  onChange={() => setVisibilityOnCV(infos?.id)}
                  checked={preferences.visibleOnCvLibrary ? true : false}
                  size="small"
                />
              }
            />
            <FormattedMessage
              id="student.profil.btnVisibleCV"
              sx={{ marginLeft: 5 }}
            />
          </Button>
          <Button
            className={css({
              height: '40px',
            })}
            onClick={handleOpenViewProfil}
            variant="outlined"
          >
            <VisibilityRounded
              style={{ marginRight: spacing(1) }}
            />
            Voir le profil
          </Button>
          <Button
            className={css({
              height: '40px',
            })}
            onClick={handleOpenCreateCV}
            variant="outlined"
          >
            <FileExport className={css({ marginRight: spacing(1) })} />
            Créer mon CV PDF
          </Button>
        </Grid>
      </div>
      <Dialog onClose={() => setOpenCropProfile(false)} open={openCropProfile}>
        <CropEasy
          {...{
            photoURL: profileImageUrl,
            setOpenCrop: setOpenCropProfile,
            type: 'profile',
            refresh: refetch,
          }}
        />
      </Dialog>
      <ModalSideBar
        displayTitle={false}
        handleClose={handleCloseViewProfil}
        open={viewProfil}
        title="Mon profil Linkpick"
        MontserratTitle={true}
      >
        <div
          style={{
            // backgroundColor: '#0060f9',
            color: '#152652',
            // borderRadius: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'start',
          }}
        >
          {profileImageUrl ? (
            <Avatar style={{ height: 80, width: 80 }} src={profileImageUrl} />
          ) : (
            <Avatar style={{ height: 80, width: 80 }}>
              {infos?.firstname?.substr(0, 1) + infos?.lastname?.substr(0, 1)}
            </Avatar>
          )}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'start',
              justifyContent: 'start',
              fontWeight: 600,
              marginLeft: spacing(2),
            }}
          >
            {infos?.firstname} {infos?.lastname}
            <div
              style={{ color: '#5D75A8', marginTop: '8px' }}
              className={cx(global.infoText, classes.address)}
            >
              <RoomIcon className={classes.imgAdress} fontSize="small" />
              {infos?.address?.cityCode} {infos?.address?.city}
            </div>
          </div>
        </div>
        <ProfilAffiliate id={idUser}
          dataForCV={
            profileImageUrl && profileImageUrl
          }
        />
      </ModalSideBar>
      <FullScreenModal
        displayTitle={false}
        handleClose={handleCloseCreateCV}
        open={openCreateCV}
        title="Créer mon CV"
        MontserratTitle={true}
      >
        <div
          style={{
            // backgroundColor: '#0060f9',
            color: '#152652',
            // borderRadius: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'start',
          }}
        >

          <CVStudent />
        </div>
      </FullScreenModal>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    borderRadius: '10px 10px 0 0',
  },
  title: {
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    height: '15vh',
    width: '100%',
    position: 'relative',
    '@media only screen and (max-width:1500px)': {
      height: '30vh',
    },
    '@media only screen and (max-width:1300px)': {
      height: '25vh',
    },
    '@media only screen and (max-width:1050px)': {
      height: '18vh',
    },
    '@media only screen and (max-width:850px)': {
      height: '15vh',
    },
    '@media only screen and (max-width:650px)': {
      height: '12vh',
    },
    '@media only screen and (max-width:500px)': {
      height: '10vh',
    },
  },

  flex: {
    // display: 'flex',
    // justifyContent: 'space-between',
    '@media only screen and (max-width:768px)': { flexDirection: 'column' },
  },
  photo: {
    width: '100%',
    position: 'relative',
  },
  ProfilNameContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
  },
  profilName: {
    marginLeft: '20px',
    marginTop: '50px',
    marginBottom: spacing(1),
  },
  ProfilButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '@media only screen and (max-width:768px)': { marginTop: spacing(2) },
  },
  actionContainer: {
    '@media only screen and (max-width:1000px)': {
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
    },
    padding: '10px 20px 20px 20px',
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
    margin: 0,
    gap: 8,
  },
  btnAction: {
    marginLeft: 'auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: spacing(2),
  },
  btnCV: {
    marginBottom: spacing(0),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginRight: spacing(2.5),
  },
  avatar: {
    marginLeft: '-90px',
    marginTop: '-15px',
    height: 80,
    width: 80,
    marginBottom: spacing(2),
  },
  œ: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: spacing(1),
  },
  name: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '@media only screen and (max-width:768px)': { marginBottom: '-20px' },
  },
  address: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: spacing(-1),
    marginTop: spacing(1.5),
  },
  icons: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginLeft: spacing(2),
  },
  icon: {
    height: 25,
    backgroundColor: '#F3F7FF',
    borderRadius: '50%',
    border: '1px solid #C0D9FF',
    marginRight: spacing(0.5),
  },
});

export default ProfilName;
